import type { Post } from '../entities/post.entity'
import type { PostRepository } from '../repositories/post_repository'

export class ListPostsUseCase {
  constructor(private readonly repository: PostRepository) {}

  execute(): Promise<Post[]> {
    return this.repository.list()
  }
}
